(() => {
  if (customElements.get('dw-shapewear-kit')) return;
  class Kit extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.closest('form');
      this.rows = [...this.querySelectorAll('[data-kit-item]')].map(row => ({
        el:row, data:row.querySelector('[data-kit-product]') ? JSON.parse(row.querySelector('[data-kit-product]').textContent) : null,
        selects:[...row.querySelectorAll('select')], manual:false
      }));
      this.rows.forEach((row,index) => row.selects.forEach(select => select.addEventListener('change',event => {
        event.stopPropagation();
        if (/^size$/i.test(select.dataset.optionName)) {
          if (index === 0) this.syncSize(); else row.manual = true;
        }
        this.validate();
      })));
      this.ready = true; this.syncSize(); this.validate();
    }
    syncSize() {
      const size = this.rows[0]?.selects.find(select => /^size$/i.test(select.dataset.optionName))?.value;
      if (!size) return;
      this.rows.slice(1).forEach(row => {
        const select = row.selects.find(select => /^size$/i.test(select.dataset.optionName));
        if (!select || row.manual) return;
        if (![...select.options].some(option => option.value === size)) {
          const option = new Option(size + ' — Unavailable',size); select.add(option);
        }
        select.value = size;
      });
    }
    validate() {
      let error = '';
      this.rows.forEach(row => {
        const variant = row.data?.variants.find(variant => row.selects.every(select => variant.options[Number(select.dataset.optionIndex)] === select.value));
        row.selects.forEach(select => select.setAttribute('aria-invalid',String(!variant)));
        if (!variant) error = 'Please choose a valid colour and size for each of the three kit items.';
        const image = row.el.querySelector('img');
        if (image && variant?.image) { image.removeAttribute('srcset'); image.src = variant.image; }
      });
      if (this.rows.length !== 3) error = 'This kit is not fully configured. Please contact us before ordering.';
      const message = this.querySelector('[data-kit-error]'); message.textContent = error; message.hidden = !error;
      return !error;
    }
  }
  customElements.define('dw-shapewear-kit',Kit);
  document.addEventListener('submit',event => {
    const kit = event.target.querySelector?.('dw-shapewear-kit');
    if (kit && (!kit.ready || !kit.validate())) { event.preventDefault(); event.stopImmediatePropagation(); kit.querySelector('[aria-invalid="true"]')?.focus(); }
  },true);
})();
